import * as Yup from 'yup'
import i18n from 'core/common/i18n'
import { DESCRIPTION_INVALID_CHARACTERS_REGEX } from 'core/common/utils/validation'
import { clearHtml } from '../ProductDescription/components/ProductTextEditor/utils/sanitize'

export const getDescriptionFormSchema = (max = 5000) =>
  Yup.object().shape({
    description: Yup.string()
      .trim(i18n.t('product.validations.invalidSpaces'))
      .transform(value => clearHtml(value))
      .max(max, i18n.t('product.scopes.description.descriptionLimit', { max }))
      .matches(
        DESCRIPTION_INVALID_CHARACTERS_REGEX,
        i18n.t('product.validations.invalidCharacters')
      )
      .required(i18n.t('product.validations.required')),
  })
